module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand-reviews"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('router-link', {
    staticClass: "button centered",
    attrs: {
      "to": {
        name: 'BrandReviewCreator'
      }
    }
  }, [_vm._v("Добавить отзыв")])], 1), _vm._v(" "), _c('draggable', {
    staticClass: "columns is-multiline mt-10 reviews-columns",
    model: {
      value: (_vm.brandReviewsObject),
      callback: function($$v) {
        _vm.brandReviewsObject = $$v
      },
      expression: "brandReviewsObject"
    }
  }, _vm._l((_vm.brandReviews), function(review) {
    return _c('BrandReviewItem', {
      key: review.id,
      staticClass: "column is-half",
      attrs: {
        "review": review
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-156901a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BrandHistory/BrandReviews.vue
// module id = 900
// module chunks = 0